import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import { showToast } from '@app/providers/ToastProvider';

export interface UserChangePasswordData {
	email: string;
	phone: string;
	branch: number;
	first_name: string;
	last_name: string;
	mfa_enabled: boolean;
	new_password: string;
	old_password: string;
}

const changePassword = configRequest<null, UserChangePasswordData>({
	requestPrefix: 'users/changePassword',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.USERS.UPDATE(),
		method: HTTP_METHODS_ENUM.PUT,
		data,
		headers: { branch: data?.branch || 0 },
	}),
	onSuccess: () => showToast.success('Password has been updated.'),
});

export default changePassword;
